export default "__VITE_ASSET__BgVgjSHf__"